.menuItem {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.menuItem:hover,
.menuItem:focus-visible {
  background: var(--colors-grays-hover);
}

.menuItem:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: transparent;
}

.menuItem .label {
  font-size: inherit;
}

.indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--colors-grays-mid);
  background: transparent;
}

.menuItem__active .indicator {
  background: var(--colors-primary-main);
  border-color: var(--colors-primary-main);
}
